import { useContext } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import heroImage from "../assets/img/hero-image.png";
import { UserContext } from "../context/userContext";

function NavigasiAdmin(props) {
  let navigate = useNavigate();
  const [state, dispatch] = useContext(UserContext);

  if (state.user.status === "customer") {
    navigate("/user");
  }

  const logout = () => {
    dispatch({
      type: "LOGOUT",
    });
    navigate("/");
  };
  return (
    <Navbar
      bg="light"
      expand="lg"
      className="bg-transparent navbar-dark"
      style={{ padding: 16 }}
    >
      <Container fluid>
        <Link to="/admin" className="d-flex align-items-center">
          <img
            src={heroImage}
            alt="Logo"
            style={{ marginRight: 24, width: 60 }}
          />
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="align-items-center">
            <Link
              to="/complain-admin"
              className={
                "text-secondary link-navigasi " +
                (props.active === "complain-admin" ? "active" : "")
              }
            >
              Complain
            </Link>
            <Link
              to="/category"
              className={
                "text-secondary link-navigasi " +
                (props.active === "category" ? "active" : "")
              }
            >
              Category
            </Link>

            <Link
              to="/product"
              className={
                "text-secondary link-navigasi " +
                (props.active === "product" ? "active" : "")
              }
            >
              Product
            </Link>
            <Nav.Link onClick={logout} className="link-navigasi text-secondary">
              Logout
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigasiAdmin;
